import * as THREE from 'three'
import { LayerOrders } from '../../shared/shared'

const DEFAULT_DEBUG_MAX = 4096

export class PhysicsDebug {
  constructor(world, { max = DEFAULT_DEBUG_MAX } = {}) {
    this.world = world
    this.scene = world.scene
    this.physics = world.physics
    this.enabled = false
    this.max = max
    this.dummy = new THREE.Object3D()

    const geometry = new THREE.PlaneGeometry(1, 1)
    geometry.translate(0.5, 0.5, 0)

    this.colors = new Float32Array(this.max * 3)
    geometry.setAttribute('aColor', new THREE.InstancedBufferAttribute(this.colors, 3))

    const material = new THREE.ShaderMaterial({
      vertexShader: /* glsl */ `
        attribute vec3 aColor;
        varying vec3 vColor;
        void main() {
          vColor = aColor;
          gl_Position = projectionMatrix * modelViewMatrix * instanceMatrix * vec4(position, 1.0);
        }
      `,
      fragmentShader: /* glsl */ `
        varying vec3 vColor;
        void main() {
          gl_FragColor = vec4(vColor, 0.35);
        }
      `,
      transparent: true,
      depthTest: false,
      depthWrite: false,
      side: THREE.DoubleSide,
    })

    this.mesh = new THREE.InstancedMesh(geometry, material, this.max)
    this.mesh.frustumCulled = false
    this.mesh.renderOrder = LayerOrders.COLLIDER
    this.mesh.count = 0
    this.mesh.visible = false
    this.scene.add(this.mesh)
  }

  toggle(enabled) {
    this.enabled = typeof enabled === 'boolean' ? enabled : !this.enabled
    this.mesh.visible = this.enabled
    if (!this.enabled) this.mesh.count = 0
  }

  update() {
    if (this.world.input.key('KeyC').pressed) {
      this.toggle()
    }
    if (!this.enabled) return

    let count = 0
    for (const box of this.physics.getBoxes()) {
      if (count >= this.max) break

      this.dummy.position.set(box.x, box.y, 0)
      this.dummy.scale.set(box.w, box.h, 1)
      this.dummy.updateMatrix()
      this.mesh.setMatrixAt(count, this.dummy.matrix)

      const i3 = count * 3
      if (box.trigger) {
        this.colors[i3] = 0
        this.colors[i3 + 1] = 1
        this.colors[i3 + 2] = 0
      } else {
        this.colors[i3] = 1
        this.colors[i3 + 1] = 0
        this.colors[i3 + 2] = 0
      }

      count++
    }

    this.mesh.count = count
    this.mesh.instanceMatrix.needsUpdate = true
    this.mesh.geometry.attributes.aColor.needsUpdate = true
  }

  destroy() {
    this.scene.remove(this.mesh)
    this.mesh.geometry.dispose()
    this.mesh.material.dispose()
  }
}
